import { useRouter } from 'next/router';
import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';
import { useGetCaseStudiesQuery, useGetRandomCaseStudiesQuery } from '../../Store/Features/CaseStudiesAPI';
import axios from 'axios';
import { HTMLParser } from '../../Common/Functions';

export default function RelatedInsights({ title = null, slug }) {
    const { data: posts, isError, isLoading } = useGetCaseStudiesQuery('/case-studies/' + slug);
    const { data: randomCaseStudies, isSuccess } = useGetRandomCaseStudiesQuery('/case-studies/random-case-studies');
    const [caseStudies, setCaseStudies] = useState([]);
    const router = useRouter();
    const [CaseStudyDetails, setCaseStudyDetails] = useState("");

    useEffect(() => {
        if (isLoading === false) {
            setCaseStudies(posts);
            HTMLParser(posts?.description, setCaseStudyDetails);
        }
    }, [posts, isLoading]);

    // Ensure only 4 case studies are displayed
    const limitedCaseStudies = randomCaseStudies?.slice(0, 4);

    return (
        <>
            <div id="relatedInsights">
                <div className="w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10">
                    <SectionHeading title={title} customClass="center" />
                    <div className="">
                        <div className="grid grid-cols-12 gap-8">
                            {limitedCaseStudies?.map((data, index) => (
                                <div key={index} className='col-span-12 overflow-hidden lg:col-span-4 md:col-span-6'>
                                    <div className="transition duration-500 cursor-pointer hover:scale-110">
                                        <Image
                                            priority={false}
                                            src={process.env.IMG_CDN + data.image}
                                            alt={data?.title}
                                            className="w-full h-auto mb-2"
                                            width={2000}
                                            height={2000}
                                        />
                                    </div>
                                    <Link href={process.env.APP_URL+"/case-study/" + data.slug}>
                                        <h4 className="text-lg font-semibold mb-2 text-[#1b5df3] line-clamp-1">{data?.title}</h4>
                                    </Link>
                                    <p className="mb-1 relatedDesc line-clamp-3">{data.short_description}</p>
                                    <Link href={process.env.APP_URL+"/case-study/" + data.slug} className="text-[#1b5df3] text-sm">
                                        View Case Study <FontAwesomeIcon icon={faArrowRight} />
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}